import { HomeRuleInfo } from './HomeRuleInfo';
export default HomeRuleInfo;
